import React  from "react";


class Home extends React.Component {
  render() {
    return (
      <div id="home">
        <h2 className="title">Home</h2>
        <h1>“Hello World”</h1>
        <p>
          りょーへーのポートフォリオサイト
          <br/>
          <b>“Hello World”</b>へようこそ！
        </p>
      </div>
    );
  }
}

export default Home;
